import { Injectable } from '@angular/core';
import { CommonApiService } from '@core/api/common.api.service';
import { IMongoResponse } from '@core/api/reponses/mongo-pagination.types';
import { IVessel } from '@dashboard/models';
import { Observable } from 'rxjs';
import { EnvVarsService } from 'src/app/env-vars.service';

type GetSites = IMongoResponse & { sites: IVessel[] };
@Injectable({
  providedIn: 'root',
})
export class SiteApiService {
  private API_URL = this.environment.getEnvKey('API_URL');
  private namespace = 'site';
  private url = `${this.API_URL}/${this.namespace}`;
  constructor(
    private common: CommonApiService,
    private environment: EnvVarsService
  ) {}

  public getSitesV2(query = ''): Observable<GetSites> {
    return this.common.get<GetSites>(`${this.url}?${query}`);
  }
}
